import { render, staticRenderFns } from "./WpItemsList.vue?vue&type=template&id=5a469002&scoped=true&"
import script from "./WpItemsList.vue?vue&type=script&lang=js&"
export * from "./WpItemsList.vue?vue&type=script&lang=js&"
import style0 from "./WpItemsList.vue?vue&type=style&index=0&id=5a469002&prod&lang=scss&scoped=true&"
import style1 from "./WpItemsList.vue?vue&type=style&index=1&id=5a469002&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a469002",
  null
  
)

export default component.exports